import { render, staticRenderFns } from "./Impact.vue?vue&type=template&id=05dd7b90&lang=pug"
import script from "./Impact.vue?vue&type=script&lang=ts"
export * from "./Impact.vue?vue&type=script&lang=ts"
import style0 from "./Impact.vue?vue&type=style&index=0&id=05dd7b90&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports